import React, { useCallback, useContext, useMemo, useState } from "react";
import { getUserData } from "../../services/userService";
import { StoreContext } from "../../Context/StoreContext";
import Loader from "../../VibehutUI/Loader";
import moment from "moment/moment";
import Repeat from "../../VibehutUI/Icons/Repeat";
import Button from "../../VibehutUI/Button";
import { checkEventSubscription } from "../../services/eventSubscriptionService";
import { openEventSubscriptionModal } from "../../actions/eventModalActions";
import { updateRsvp } from "../../services/eventService";
import { videoAppUrl } from "../../utils/axios";
import useIsPWA from "../../hooks/usePWA";
import { getNotificationSettings } from "../../services/notificationService";
import { showNotificationActionModal } from "../../actions/uiModalActions";
import ConfirmationModal from "../../VibehutUI/ConfirmationModal";
import * as actionTypes from "../../constants";
import globals from "../../globals";
import { getMyEvents } from "../../actions/eventActions";

function AllInvitedEvents({ events }) {
  const { state, dispatch } = useContext(StoreContext);
  const [isStatusUpdating, setIsStatusUpdating] = useState("");
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [eventId, setEventId] = useState(null);
  const isPWA = useIsPWA();
  const {
    auth: { user },
    accessPass,
  } = state;

  const _renderEventTime = useCallback((event) => {
    let timeRangeString = "";
    var startTime = moment(event.startDate);
    var endTime = moment(event.endDate);

    const currntTime = moment().format();
    const isLive =
      moment(event.startDate).format() < currntTime &&
      moment(event.endDate).format() > currntTime;

    var today = moment().endOf("day");
    var tomorrow = moment().add(1, "days").endOf("day");

    const isAMsame = startTime.format("a") === endTime.format("a");
    if (startTime.format("mm") === "00") {
      timeRangeString =
        timeRangeString + startTime.format(`h${isAMsame ? "" : " A"}`);
    } else {
      timeRangeString =
        timeRangeString + startTime.format(`h:mm${isAMsame ? "" : " A"}`);
    }
    timeRangeString = timeRangeString + "-";
    if (endTime.format("mm") === "00") {
      timeRangeString = timeRangeString + endTime.format("h A");
    } else {
      timeRangeString = timeRangeString + endTime.format("h:mm A");
    }
    const zone = moment.tz.guess();
    const abbr = moment.tz(zone).format("z");
    if (isLive) {
      return (
        <div className="flex flex-row items-center">
          <div className="">LIVE</div>
          <span className="live-pulse"></span>
        </div>
      );
    }

    if (event?.isRecurrEvent) {
      if (endTime < new Date()) {
        return (
          <div className="inline-block items-start">
            <Repeat />
            {startTime.format("MMM D,")} {timeRangeString} {abbr}
          </div>
        );
      }
      if (startTime < today) {
        return (
          <div className="inline-block items-start">
            <Repeat /> TODAY {timeRangeString} {abbr}
          </div>
        );
      }
      if (startTime < tomorrow) {
        return (
          <div className="inline-block items-start">
            <Repeat /> TOMORROW {timeRangeString} {abbr}
          </div>
        );
      }
      return (
        <div className="inline-block items-start">
          <Repeat /> {startTime.format("MMM D,")} {timeRangeString} {abbr}
        </div>
      );
    } else {
      if (endTime < new Date()) {
        return `${startTime.format("MMM D,")} ${timeRangeString} ${abbr}`;
      }
      if (startTime < today) {
        return `TODAY ${timeRangeString} ${abbr}`;
      }
      if (startTime < tomorrow) {
        return `TOMORROW ${timeRangeString} ${abbr}`;
      }
      return `${startTime.format("MMM D,")} ${timeRangeString} ${abbr}`;
    }
  }, []);

  const isAccessPassHolder = useMemo(
    (event) => {
      if (!accessPass?.data) return false;
      if (!event?.room?._id) return false;

      const pass = accessPass.data?.find(
        (pass) => pass.kind === "room" && pass.refItem === event.room._id
      );

      return !!pass;
    },
    [accessPass?.data]
  );

  const isModerator = (event) => {
    if (event.room?.owner?._id?.toString() === user._id.toString()) return true;
    if (event.room.moderators) {
      for (let i = 0; i < event.room.moderators.length; i++) {
        if (event.room.moderators[i].toString() === user._id.toString())
          return true;
      }
    }
    return false;
  };

  const updateHomePageEvents = async () => {
    await getMyEvents(user?.token, dispatch);
    globals.hideModal();
  };

  const handleUserRsvp = async (rsvpStatus, event) => {
    setEventId(event._id);
    const currntTime = moment().format();
    const isLive =
      moment(event.startDate).format() < currntTime &&
      moment(event.endDate).format() > currntTime;
    const eventSubscriberList = event.eventSubscriptions;
    const maxAttendees = event.room.maxUsersPerGroup;
    const spotsLeft = maxAttendees - eventSubscriberList.length - 1;
    try {
      setIsStatusUpdating(rsvpStatus);
      if (
        event.isPaidEvent &&
        event.owner !== user._id &&
        !isModerator(event) &&
        !isAccessPassHolder(event)
      ) {
        const checkSubscription = await checkEventSubscription(
          user.token,
          event._id
        );
        if (!checkSubscription?.data?.checkSubscription) {
          openEventSubscriptionModal(
            dispatch,
            event,
            `${event.title} is $${event.price} to attend. ${
              spotsLeft > 1
                ? `There are ${spotsLeft} spots left.`
                : `There is ${spotsLeft} spot left.`
            }`,
            "rsvp"
          );
        } else {
          if (isLive) {
            if (rsvpStatus === "confirmed") {
              await updateRsvp(
                { event: event._id, status: rsvpStatus },
                user.token
              );
              await updateHomePageEvents();
            }
            if (!isPWA) {
              window.open(
                `${videoAppUrl}/call?roomKey=${
                  event.room[0]?._id || event.room?._id
                }`
              );
            } else {
              window.location.href = `${videoAppUrl}/call?roomKey=${
                event.room[0]?._id || event.room?._id
              }`;
            }
            return;
          }
          await updateRsvp(
            { event: event._id, status: rsvpStatus },
            user.token
          );
          await updateHomePageEvents();
          if (rsvpStatus === "confirmed") {
            await getNotificationSettings(user.token)
              .then((res) => {
                const _notificationSettings = res.data.notificationSettings;
                if (
                  !_notificationSettings.email.isEmailVerified &&
                  !_notificationSettings.phoneNumber.isPhoneNumberVerified
                ) {
                  showNotificationActionModal(dispatch);
                }
              })
              .catch((err) => console.log("NOTIFICATION SETTINGS err:", err));
          }
        }
      } else {
        if (isLive) {
          if (rsvpStatus === "confirmed") {
            await updateRsvp(
              { event: event._id, status: rsvpStatus },
              user.token
            );
            await updateHomePageEvents();
          }
          if (!isPWA) {
            window.open(
              `${videoAppUrl}/call?roomKey=${
                event.room[0]?._id || event.room?._id
              }`
            );
          } else {
            window.location.href = `${videoAppUrl}/call?roomKey=${
              event.room[0]?._id || event.room?._id
            }`;
          }
        }
        if (event.isRecurrEvent && rsvpStatus === "confirmed") {
          setOpenConfirmationModal(true);
        } else {
          await rsvpBasedOnUserPrompt(false, rsvpStatus, event);
        }
      }
    } finally {
      setIsStatusUpdating("");
      setEventId(null);
    }
  };

  const rsvpBasedOnUserPrompt = async (
    isGroupRSVP = false,
    rsvpStatus,
    event
  ) => {
    try {
      setIsStatusUpdating(rsvpStatus);
      setTimeout(() => {}, 3000);
      const response = await updateRsvp(
        {
          event: event._id,
          status: rsvpStatus,
          ...(isGroupRSVP && {
            isGroupRSVP: true,
          }),
        },
        user.token
      );
      if (response.data.message) {
        dispatch({
          type: actionTypes.SET_RSVP_EVENT_ERROR_MESSAGE,
          payload: {
            message: response.data.message,
          },
        });
        return;
      }

      //  setEvent(response.data.rsvp.event);
      if (rsvpStatus === "confirmed") {
        getNotificationSettings(user.token)
          .then((res) => {
            const _notificationSettings = res.data.notificationSettings;
            if (
              !_notificationSettings.email.isEmailVerified &&
              !_notificationSettings.phoneNumber.isPhoneNumberVerified
            ) {
              showNotificationActionModal(dispatch);
            }
          })
          .catch((err) => console.log("NOTIFICATION SETTINGS err:", err));
      }
      await updateHomePageEvents();
    } finally {
      setIsStatusUpdating("");
    }
  };

  const findEventStatus = (event, status) => {
    const item = event.rsvps?.find(
      (rsvp) => rsvp.user._id === user?._id && rsvp.status === status
    );
    return !!item;
  };

  return (
    <>
      <div className=" justify-center py-4  rounded-2xl h-80 overflow-auto custom-scrollbar">
        <div>
          <div className="flex flex-row items-center gap-4 w-full">
            <div className="w-full flex flex-col gap-3">
              {events.map((event) => {
                return (
                  <div
                    key={event._id}
                    className="dark:text-frescoWhite border border-frescoWhite dark:border-matteGray p-2 rounded"
                  >
                    <div className="flex items-center justify-center">
                      <p>{event.title}</p>
                    </div>

                    <div className="flex flex-col items-center justify-center gap-2 py-2">
                      <p>{_renderEventTime(event)}</p>
                      <div className="flex gap-2 items-center">
                        <Button
                          variant="vibhut-primary"
                          onClick={() => handleUserRsvp("confirmed", event)}
                          disabled={
                            isStatusUpdating ||
                            event.owner === user?._id ||
                            event.room.owner === user?._id
                          }
                        >
                          <span className="flex gap-4 items-center">
                            <span>Attend</span>
                            {isStatusUpdating === "confirmed" &&
                            event._id === eventId ? (
                              <Loader color="#fff" ratio="h-4 w-4" />
                            ) : (
                              <></>
                            )}
                          </span>
                        </Button>
                        <Button
                          variant="secondary"
                          onClick={() => handleUserRsvp("maybe", event)}
                          disabled={
                            isStatusUpdating ||
                            findEventStatus(event, "maybe") ||
                            event.owner === user?._id ||
                            event.room.owner === user?._id ||
                            moment(event.endDate) < moment.now()
                          }
                        >
                          <span className="flex gap-4 items-center">
                            <span>Maybe</span>
                            {isStatusUpdating === "maybe" &&
                            event._id === eventId ? (
                              <Loader ratio="h-4 w-4" />
                            ) : (
                              <></>
                            )}
                          </span>
                        </Button>
                        <Button
                          variant="secondary"
                          onClick={() => handleUserRsvp("declined", event)}
                          disabled={
                            isStatusUpdating ||
                            findEventStatus(event, "declined") ||
                            event.owner === user?._id ||
                            event.room.owner === user?._id ||
                            moment(event.endDate) < moment.now()
                          }
                        >
                          <span className="flex gap-4 items-center">
                            <span>
                              {findEventStatus(event, "declined")
                                ? "Declined"
                                : "Decline"}
                            </span>
                            {isStatusUpdating === "declined" &&
                            event._id === eventId ? (
                              <Loader ratio="h-4 w-4" />
                            ) : (
                              <></>
                            )}
                          </span>
                        </Button>
                      </div>
                      <p className="text-primaryGray">
                        {getUserData(event.host).username} invited you
                      </p>
                    </div>
                    {openConfirmationModal && event?._id === eventId && (
                      <ConfirmationModal
                        title="Attend Event"
                        text={
                          "This is a recurring event. Would you like to attend:"
                        }
                        openModal={openConfirmationModal}
                        setOpenModal={setOpenConfirmationModal}
                        primaryButtonText="Yes"
                        primaryAction={(index) => {
                          setOpenConfirmationModal(false);
                          if (index === 1 || !index) {
                            rsvpBasedOnUserPrompt(false, "confirmed", event);
                          }
                          if (index === 2) {
                            rsvpBasedOnUserPrompt(true, "confirmed", event);
                          }
                        }}
                        secondaryButtonText={"No"}
                        secondaryAction={() => {
                          setOpenConfirmationModal(false);
                        }}
                        radioBoxData={[
                          "Only this event",
                          "This and following events",
                        ]}
                      />
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AllInvitedEvents;
